import React, { useEffect, useState } from 'react';
import GradientDivider from '../../components/gradientDivider';
import useStyles from './style';
import Flex from '../../components/flex';
import Text from '../../components/text';
import { colors } from '../../config/theme';
import { ReactComponent as WarningSVG } from '../../assets/icons/warning.svg';
import { ReactComponent as CheckSVG } from '../../assets/icons/check-large.svg';
import { ReactComponent as LogoSVG } from '../../assets/icons/ThorneHealthLogo.svg';
import Element from '../../components/element';
import { PRE_REG_QUESTIONS_URL } from '../../api/endpoints';
import { useDispatch } from 'react-redux';
import { apiRequest } from '../../api/actions';
import { get, groupBy, map, sortBy } from 'lodash';
import useAuth from '../../root/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';

const PreRegistration = () => {
  const [modifierQuestions, setModifierQuestions] = useState([]);
  const [disqualifierQuestions, setDisqualifierQuestions] = useState([]);
  const [checkedModifiersCount, setCheckedModifiersCount] = useState(0);
  const [checkedDisqualifiersCount, setCheckedDisqualifiersCount] = useState(0);
  const [error, setError] = useState('');
  const [warning, setWarning] = useState('');
  const [signupSuccess, setSignupSuccess] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const { b2cLogin } = useAuth(false);

  const onChecked = que => e => {
    que.checked = e.target.checked;
    if (que.type === 'modifiers') {
      setCheckedModifiersCount(
        que.checked ? checkedModifiersCount + 1 : checkedModifiersCount - 1
      );
    } else {
      setCheckedDisqualifiersCount(
        que.checked
          ? checkedDisqualifiersCount + 1
          : checkedDisqualifiersCount - 1
      );
    }
  };

  const onSubmit = () => {
    const request = {
      method: 'put',
      url: PRE_REG_QUESTIONS_URL,
      data: {
        mrn: get(location, 'state.mrn'),
        preScreenQuestions: [...disqualifierQuestions, ...modifierQuestions]
      }
    };
    const meta = {
      onSuccess: res => {
        const error = res?.data?.error;
        if (error) {
          setError(error.message);
        } else {
          setSignupSuccess(true);
          navigate('/questionarie', { replace: true });
        }
      }
    };

    dispatch(apiRequest(request, meta));
  };

  const onClickCancel = () => {
    navigate('/');
  };

  const pullQuestions = () => {
    const request = {
      method: 'get',
      url: PRE_REG_QUESTIONS_URL
    };
    const meta = {
      onSuccess: res => {
        let questions = res?.data?.data;
        const group = groupBy(questions, 'type');
        setDisqualifierQuestions(sortBy(group.disqualifiers, 'displayOrder'));
        setModifierQuestions(sortBy(group.modifiers, 'displayOrder'));
        setWarning(res?.data?.message);
      }
    };

    dispatch(apiRequest(request, meta));
  };

  useEffect(() => {
    if (!get(location, 'state.mrn')) {
      navigate('/signup', { replace: true });
    } else {
      pullQuestions();
    }
  }, []);

  return (
    <div className={classes.prereg}>
      <Element type={LogoSVG} width="25%" />
      <GradientDivider />
      {!signupSuccess && (
        <>
          <Element type="div" paddingRight="40%">
            <Text
              family="GTAM"
              size="21px"
              color={colors.mineShaft}
              margin="8px 0"
            >
              Patient Pre-Screening{' '}
            </Text>
            <Text
              family="GTAR"
              color={colors.mineShaft}
              weight={500}
              margin="0 0 25px"
            >
              Please check if any of the following apply:
            </Text>
            {map(disqualifierQuestions, que => (
              <Flex className={classes.field}>
                <input
                  type="checkbox"
                  id={que._id}
                  name={que.name}
                  value={que.name}
                  className={classes.radioInput}
                  onChange={onChecked(que)}
                />
                <label htmlFor={que._id} className={classes.fieldLabel}>
                  {que.name}
                </label>
              </Flex>
            ))}
            {error && !!checkedDisqualifiersCount && (
              <Flex align="baseline">
                <Element
                  type={WarningSVG}
                  width="12px"
                  height="12px"
                  marginRight="4px"
                />
                <Text
                  family="GTAM"
                  color={colors.ceriseRed}
                  size="12px"
                  margin="20px 0"
                >
                  {error}
                </Text>
              </Flex>
            )}
            {map(modifierQuestions, que => (
              <Flex className={classes.field}>
                <input
                  type="checkbox"
                  id={que._id}
                  name={que.name}
                  value={que.name}
                  className={classes.radioInput}
                  onChange={onChecked(que)}
                />
                <label htmlFor={que._id} className={classes.fieldLabel}>
                  {que.name}
                </label>
              </Flex>
            ))}
            {warning && !!checkedModifiersCount && (
              <Flex align="baseline" marginTop="12px">
                <Element
                  type={WarningSVG}
                  className={classes.yellowWarning}
                  width="20px"
                  height="12px"
                  marginRight="4px"
                />
                <Text family="GTAM" size="12px" color={colors.mineShaft}>
                  {warning}
                </Text>
              </Flex>
            )}
            <Flex marginTop="80px">
              <button className={classes.btn} onClick={onClickCancel}>
                Cancel
              </button>
              <button
                className={`${classes.btn} ${classes.submit}`}
                // disabled={!checkedDisqualifiersCount && !checkedModifiersCount}
                onClick={onSubmit}
              >
                Submit
              </button>
            </Flex>
          </Element>
          <p className={classes.footer}>
            © {new Date().getFullYear()} Thorne Healthcare ・ Privacy Policy
          </p>
        </>
      )}
      {signupSuccess && (
        <Element textAlign="center">
          <Element
            type={CheckSVG}
            margin="34px 0 16px"
            width="64px"
            height="64px"
          />
          <Text family="GTAM" size="21px">
            Success! Check your email for login instructions.
          </Text>
          <Element
            type="button"
            className={`${classes.btn} ${classes.submit}`}
            marginTop="48px"
            attrs={{ onClick: b2cLogin }}
          >
            Continue to Login
          </Element>
        </Element>
      )}
    </div>
  );
};

export default PreRegistration;
